import { Box, Button, Typography } from "@mui/material";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "../Common/DialogBox";
export interface ICheckForFaultBox {
  displayNextSlide: () => void;
}

const CheckForFaultBoxComponents = (props: ICheckForFaultBox) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.positionComponent}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <DialogBox
        childProps={
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              height: "inherit",
              width: "inherit",
            }}
          >
            <div>
              <Typography
                variant="subtitle2"
                color="white"
                sx={{ fontWeight: "700", fontSize: "1rem" }}
                component="span"
              >
                Lets check for faults
              </Typography>
              <Typography
                color="white"
                sx={{ fontWeight: "700", fontSize: "1rem" }}
              >
                in the machine to make sure if the
              </Typography>
              <Typography
                variant="subtitle2"
                color="white"
                sx={{ fontWeight: "700", fontSize: "1rem" }}
              >
                computers are operational?
              </Typography>
            </div>
            <Button
              sx={{
                borderRadius: "3rem",
                textTransform: "capitalize",
                padding: "1rem 0.5rem",
                fontSize: "0.8rem",
                fontWeight: "600",
                backgroundColor: "#56CCF2",
                width: "70%",
                color: "#004D66",
              }}
              variant="contained"
              onClick={() => {
                props.displayNextSlide();
              }}
            >
              Check for faults
            </Button>
            <Button
              sx={{
                textTransform: "capitalize",
                color: "#56CCF2",
                fontSize: "0.8rem",
              }}
            >
              Cancel
            </Button>
          </div>
        }
        type={1}
      />
    </Box>
  );
};

export default CheckForFaultBoxComponents;
